import { render, staticRenderFns } from "./CandidateListAddNew.vue?vue&type=template&id=93de2268&"
import script from "./CandidateListAddNew.vue?vue&type=script&lang=js&"
export * from "./CandidateListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CandidateListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports